import { signOnModalId } from '../../pages/IndexPage/IndexPage';

/** Closing auth modal helper. */
export const closeAuthModal = (): void => {
  // eslint-disable-next-line no-undef
  $(`#${signOnModalId}`).modal('hide');
};
